var map = {
	"./57_legs.mp3": "2f0e",
	"./58_hands.mp3": "6202",
	"./59_head.mp3": "92de",
	"./60_tummy.mp3": "31ca",
	"./M_Brilliant.mp3": "94ce",
	"./M_Excellent.mp3": "b8a0",
	"./M_Fantastic.mp3": "602f",
	"./M_Great.mp3": "bc00",
	"./M_Perfect.mp3": "3c90",
	"./M_Think again.mp3": "d890",
	"./M_Try again.mp3": "9bf0",
	"./M_Very good.mp3": "5ef4",
	"./M_Well done.mp3": "aac3",
	"./M_Work harder.mp3": "a46c",
	"./click.mp3": "d2de",
	"./false.mp3": "5123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be2b";